
































































































































































import Routes from '@/Routes';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AppEvents from '@/AppEvents';
import IApiError from '@/models/IApiError';

@Component({
  components: {
  },
})
export default class ResetPasswordPage extends Vue {
  loading: boolean = false;
  passwordVisible: boolean = false;
  emailInputDisabled: boolean = false;
  resetPasswordApiErrors: IApiError[] = [];
  get requireExternalAuthTenantLogin(): boolean {
    return this.resetPasswordApiErrors.some(apiError => apiError.code.includes("email_domain_reserved_for_authtenant"));
  }

  signinErrorMessage: string = null;
  model: any = {
      email: '',
      password: '',
      confirmPassword: '',
      code: ''
  }
  validatingEmailAndCode: boolean = false;
  newPasswordSaved: boolean = false;

  $tlang: any;

  rules: any = {
      required: value => !!value 
        || this.$i18n.translate("validation.rules.required", "Required"),
      email: v => /.+@.+/.test(v) 
        || this.$i18n.translate("validation.rules.email", "Must be a valid email address"),
      passwordLength: v => v.length >= 8           
        || this.$i18n.translate(
            "validation.rules.password", 
            "Password must be at least 8 characters long"
          ),
      passwordContainsUppercase: v => {
         return (
            /[A-Z]/.test(v)            
            || this.$i18n.translate(
                "validation.rules.passwordContainsUppercase", 
                "Password must contain at least one uppercase character"
              )
          )
      },
      passwordContainsLowercase: v => {
         return (
            /[a-z]/.test(v)          
            || this.$i18n.translate(
                "validation.rules.passwordContainsLowercase", 
                "Password must contain at least one lowercase character"
              )
          )
      },
      passwordContainsNumber: v => {
         return (
            /[0-9]/.test(v)           
            || this.$i18n.translate(
                "validation.rules.passwordContainsNumber", 
                "Password must contain at least one number"
              )
          )
      },
      confirmPassword: v => {
          return (
            this.model.password === this.model.confirmPassword 
              || this.$i18n.translate("validation.rules.confirmPassword", "Passwords do not match")
          );
        }
      }

  setLocale(locale){
    this.$store.dispatch("app/setLocale", locale);
  }

  isValidEmail(email: string): boolean {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,16})+$/.test(email); 
  }

  async created(){
    this.model.email = this.$route.query.email;
    this.model.code = this.$route.query.code;

    if (this.model.email && this.model.code){
      this.validatingEmailAndCode = true;
      if(this.isValidEmail(this.model.email)){
        this.emailInputDisabled = true;
      }
      try {
        await this.$store.dispatch(
          'user/validateResetPasswordCode', 
          { 
            data: {
              email: this.model.email,
              code: this.model.code
            }
          }
        );
      } catch (e) {
        this.resetPasswordApiErrors = AppEvents.getApiErrorsFromError(e);
        this.loading = false;
      }
      this.validatingEmailAndCode = false;
    }
  }

 
  async onSaveNewPasswordClick() {
    // if (!((this.$refs.resetPasswordForm as any).validate())) {
    //     return;
    // }
    this.resetPasswordApiErrors = [];
    this.newPasswordSaved = false;
    this.loading = true;
    try {
        await this.$store.dispatch(
          'user/resetPassword', 
          { 
            data: this.model 
          }
        );
    } catch (e) {
        this.resetPasswordApiErrors = AppEvents.getApiErrorsFromError(e);
        this.loading = false;
        return;
    }
    this.newPasswordSaved = true;
    this.loading = false;
  }

  async onSignInClick() {
    this.signinErrorMessage = null;
    this.loading = true;
    try {
        const loginResult = await this.$store.dispatch(
          'auth/authRequest', 
          {username: this.model.email, password: this.model.password}
        );
    } catch (e) {
        this.signinErrorMessage = e.toString();
        console.error("loginError", e);
        this.loading = false;
        return;
    }
    this.$root.$emit(AppEvents.APP_LOGIN_SUCCESS);
    this.loading = false;
    // 
    if (this.$route.query && this.$route.query.redirect){
      this.$router.push(this.$route.query.redirect.toString());
    } else {
      this.$router.push(Routes.rootRoute);
    }
  }

  async onAzureAdSignInClick() {
    const routeOptions = { name: Routes.signInAzureAdRoute.name, query: this.$route.query };
    const route = this.$router.resolve(routeOptions);
    const callbackUrl = new URL(route.href, window.location.href).href;
    console.log(callbackUrl);

    const backendAzureAdLoginUrl =  [
      process.env.VUE_APP_API_HOST,
      "/ExternalAuth/AzureAdSignIn",
      "?callbackUrl=",
      encodeURIComponent(callbackUrl),
      "&loginHint=",
      encodeURIComponent(this.model.email)
    ].join("");
   
    console.log(backendAzureAdLoginUrl);
    document.location.href = backendAzureAdLoginUrl;
  }
};
